import React, { Component } from "react";
import { FormGroup } from "react-bootstrap";
import ToolPicker from "../components/ToolPicker";
import { navbarSetup, toolSerialNoValidate, fieldChangeCase } from "../libs/utils";
import { getTools, addTool, removeTool } from "../libs/db-lib";
import LoaderButton from "../components/LoaderButton";
import AlertModal from "../components/AlertModal.tsx";
import { Loading } from "../components/Loading.tsx";
import CustomTable from "../components/CustomTable.tsx";
import ConfirmModal from "../components/ConfirmModal.tsx";
import SliderModal from "../components/SliderModal.tsx";
import TextInput from "../components/TextInput.tsx";

export default class ManageTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serialNumber: "",
      manufacturer: {},
      model: {},
      alertMessage: "",
      showModal: false,
      filter: "",
      showDeleteModal: false,
      user: props.user,
      verifySerialNumber: false,
      tools: [],
      isLoading: true,
      isLoadingAddTool: false,
      showAddToolModal: false,
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
    try {
      // await resetUserData(this);
      let tools = await getTools();
      this.setState({
        tools: tools.toolList ? tools.toolList : [],
        filteredTools: tools.toolList ? tools.toolList : [],
      });
    } catch (e) {
      this.setState({
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
      });
    }
    this.setState({
      isLoading: false,
      windowWidth: window.outerWidth,
    });
    window.addEventListener("resize", this.setWindowWidth.bind(this));
  }

  setWindowWidth() {
    setTimeout(this.setStateWidth.bind(this), 20);
  }

  setStateWidth() {
    this.setState({ windowWidth: window.outerWidth });
  }

  validateForm() {
    let serialNumberValid = toolSerialNoValidate(this.state.serialNumber);

    return (
      this.state.serialNumber.length > 0 &&
      this.state.manufacturer.manufacturerUUID &&
      this.state.model.modelUUID &&
      serialNumberValid
    );
  }

  activateSerialNumberVerify() {
    this.setState({ verifySerialNumber: true });
  }

  async handleConfirmModal() {
    // Handle delete of tool
    try {
      await removeTool(this.state.toolToDelete);
      this.handleRemoveTool(this.state.toolToDelete);
    } catch (e) {
      this.setState({
        alertMessage: e.message,
        showModal: true,
      });
    }

    this.setState({
      showDeleteModal: false,
      toolToDelete: "",
    });
  }

  handleCancelAddTool() {
    this.setState({ showAddToolModal: false })
  }

  handleOpenAddToolModal() {
    this.setState({ showAddToolModal: true });
  }

  handleCancelModal(e) {
    this.setState({ showDeleteModal: false, toolToDelete: "" });
  }

  handleDeleteButton(toolId, toolName) {
    this.setState({ showDeleteModal: true, toolToDelete: toolId, toolNameToDelete: toolName });
  }

  handleToolChange(manufacturer, model) {
    this.setState({ manufacturer: manufacturer, model: model });
  }

  handleManufacturerChange(manufacturer) {
    this.setState({ manufacturer: manufacturer });
  }

  handleGridSizeChanged(sizeInfo) {
    sizeInfo.api.sizeColumnsToFit();
  }

  handleChange = (event) => {
    if (event.target.id === "serialNumber") {
      fieldChangeCase(this, event.target, "upper");
      this.activateSerialNumberVerify();
    } else {
      this.setState({
        [event.target.id]: event.target.value,
      });
      if (event.target.id === "filter") {
        if (event.target.value.length > 0) {
          const filterArr = event.target.value
            ? event.target.value.split(" ").filter((f) => f !== "")
            : [];
          const filterStr = filterArr.reduce((f1, f2) => f1 + "|" + f2);
          const regexStr = new RegExp("(?:" + filterStr + ")", "ig");
          const toolList = this.state.tools.filter((t) => {
            return (
              regexStr.test(t.toolManufacturer) ||
              regexStr.test(t.toolModel) ||
              regexStr.test(t.toolSerial)
            );
          });
          this.setState({
            filteredTools: toolList ? toolList : [],
          });
        } else {
          this.setState({
            filteredTools: this.state.tools,
          });
        }
      }
    }
  };

  updateFilteredList(tools) {
    if (this.state.filter.length > 0) {
      const filterArr = this.state.filter.split(" ").filter((f) => f !== "");
      const filterStr = filterArr.reduce((f1, f2) => f1 + "|" + f2);
      const regexStr = new RegExp("(?:" + filterStr + ")", "ig");
      const toolList = tools.filter((t) => {
        return (
          regexStr.test(t.toolManufacturer) ||
          regexStr.test(t.toolModel) ||
          regexStr.test(t.toolSerial)
        );
      });
      this.setState({
        filteredTools: toolList ? toolList : [],
      });
    } else {
      this.setState({
        filteredTools: tools,
      });
    }
  }

  handleRemoveTool(toolId) {
    // Update the tool table
    let tools = this.state.tools;
    let newTools = tools.filter((tool) => {
      return tool.toolID !== toolId;
    });
    this.setState({
      tools: newTools,
    });
    this.updateFilteredList(newTools);
  }

  handleCancel = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    let data = this.state;

    const ownedTool = data.tools.find((t) => {
      return t.toolModel === data.model.model && t.toolSerial === data.serialNumber;
    });
    if (ownedTool) {
      this.setState({
        alertMessage: "This tool is already entered in the system",
        showModal: true,
      });
    } else {
      this.setState({ isLoadingAddTool: true });
      let results = await addTool(
        data.serialNumber,
        data.manufacturer.manufacturerUUID,
        data.model.modelUUID
      );
      if (results.error) {
        this.setState({
          alertMessage: results.error,
          showModal: true,
          isLoadingAddTool: false,
        });
      } else {
        let newTool = {
          toolManufacturer: data.manufacturer.manufacturer,
          toolModel: data.model.model,
          toolSerial: data.serialNumber,
          toolID: results.toolID,
        };
        let tools = this.state.tools;
        tools.push(newTool);

        this.updateFilteredList(tools);

        this.setState({
          alertMessage: "Tool Added!",
          showModal: true,
          serialNumber: "",
          verifySerialNumber: false,
          tools: tools,
          isLoadingAddTool: false,
          showAddToolModal: false,
        });
      }
    }
  };

  render() {
    const columnDefs = [];
    columnDefs.push({
      header: "Manufacturer",
      accessorKey: "manufacturer",
      size: 150,
      enableGrow: true,
    });
    if (this.state.windowWidth > 500) {
      columnDefs.push({
        header: "Model",
        accessorKey: "model",
        size: 100,
        enableGrow: true,
      });
    }
    columnDefs.push({
      header: "Serial No.",
      id: "serialNo",
      accessorKey: "serialNo",
      className: "tool-sn-font",
      size: this.state.windowWidth > 600 ? 200 : 100,
    });
    columnDefs.push({
      header: this.state.windowWidth > 500 ? "Actions" : "",
      id: "toolId",
      size: this.state.windowWidth > 500 ? 90 : 50,
      className: "flex-center",
      cell: ({row}) => {
        return (
          <div>
            <button
              className="c-btn-icon-compact"
              onClick={this.handleDeleteButton.bind(
                this,
                row.original.toolId,
                row.original.serialNo
              )}
            >
              <div className="c-btn__inner">
                <span
                  className="c-btn__icon fal fa-times-circle"
                  title="Remove from System"
                />
              </div>
            </button>
          </div>
        );
      },
      suppressSorting: true,
      suppressFilter: true,
    });

    let tools = this.state.filteredTools
      ? this.state.filteredTools.map((tool) => {
          return {
            toolId: tool.toolID,
            manufacturer: tool.toolManufacturer,
            model: tool.toolModel,
            serialNo: tool.toolSerial,
          };
        })
      : [];

    return (
      <div className="home">
        <div className="panel-frame">
          {this.state.user && this.state.user.shop !== "" ? (
            <>
              {!this.state.isLoading ? (
                <>
                  <h2 className="c-page-heading">Tools</h2>
                  <div
                    className={
                      this.state.windowWidth > 400
                        ? "col-lg-9 col-md-10"
                        : "col-lg-9 col-md-10 no-left-padding"
                    }
                  >
                    <button
                      className="c-btn u-margin-bottom-large"
                      onClick={this.handleOpenAddToolModal.bind(this)}
                    >
                      <i className="c-btn__icon fal fa-plus"></i>
                      Add Tool
                    </button>
                    <div className="auto-auth-table col-sm-12">
                      <TextInput
                        controlID="filter"
                        label="Filter"
                        value={this.state.filter}
                        onChange={this.handleChange.bind(this)}
                      />
                      <CustomTable
                        columns={columnDefs}
                        data={tools}
                        className="-highlight u-margin-top-large"
                        paginationTop
                        paginationBottom
                        noDataText="No Tools"
                        defaultSort={[
                          {
                            id: 'serialNo',
                            desc: false,
                          },
                        ]}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <Loading />
              )}
            </>
          ) : (
            ""
          )}
        </div>

        <AlertModal
          message={this.state.alertMessage}
          showModal={this.state.showModal}
          handleCancel={this.handleCancel.bind(this)}
        />

        <ConfirmModal
          showModal={this.state.showDeleteModal}
          handleCancel={this.handleCancelModal.bind(this)}
          handleConfirm={this.handleConfirmModal.bind(this)}
          title="Confirm Remove Tool from System"
          message={`Are you sure you want to remove the tool ${this.state.toolNameToDelete}?`}
          confirmLoadingText="Removing Tool..."
        />

        <SliderModal
          showModal={this.state.showAddToolModal}
          handleCancel={this.handleCancelAddTool.bind(this)}
          title="Add Tool"
          body={
            <div className="l-container-sm">
              <form onSubmit={this.handleSubmit}>
                <div className="col-sm-8 text-center">
                  <ToolPicker
                    manufacturer={
                      this.state.manufacturer.manufacturerUUID
                        ? this.state.manufacturer.manufacturerUUID
                        : ""
                    }
                    model={this.state.model.modelUUID ? this.state.model.modelUUID : ""}
                    handleToolChange={this.handleToolChange.bind(this)}
                    handleManufacturerChange={this.handleManufacturerChange.bind(this)}
                  />
                  <TextInput
                    controlID="serialNumber"
                    label="Serial Number"
                    value={this.state.serialNumber}
                    onChange={this.handleChange}
                    className="monospace"
                    errorCondition={this.state.verifySerialNumber
                      && !toolSerialNoValidate(this.state.serialNumber)}
                    errorMsg="Serial Number cannot be blank and can only
                      contain alphanumeric plus '-_/.' characters"
                  />
                  <FormGroup>
                    <div className="parent-center">
                      <LoaderButton
                        block
                        className="btn-container red-button"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoadingAddTool}
                        text="Add Tool"
                        loadingText="Adding tool…"
                      />
                    </div>
                  </FormGroup>
                </div>
              </form>
            </div>
          }
        />
      </div>
    );
  }
}
